import { DASHBOARD_API_ORIGIN, TABLET_API_ORIGIN } from '@/global/env';
import { RestClientInterface } from '@/lib/restClient';

export interface SigninForm {
  email: string;
  password: string;
}

export interface RegistrationForm {
  password: string;
  one_time_token: string;
}

export interface PasswordResetRequestForm {
  email: string;
}

export interface PasswordResetForm {
  password: string;
  one_time_token: string;
}

export interface ResendEmailRequestForm {
  email: string;
}

export interface ValidateTokenForm {
  token: string;
}

interface Interface {
  signin: (body: SigninForm) => Promise<void>;
  registration: (body: RegistrationForm) => Promise<void>;
  passwordReset: (body: PasswordResetForm) => Promise<void>;
  passwordResetRequest: (body: PasswordResetRequestForm) => Promise<void>;
  resendEmailRequest: (body: ResendEmailRequestForm) => Promise<void>;
  validateToken: (body: ValidateTokenForm) => Promise<void>;
}

export class AuthService implements Interface {
  constructor(private readonly restClient: RestClientInterface) {}

  public async signin(body: SigninForm): Promise<void> {
    return await this.restClient.post<SigninForm, void>(
      `${DASHBOARD_API_ORIGIN}/signin` as const,
      body
    );
  }

  // NOTE 認証形APIでアカウント登録の時はタブレットのapiを叩く
  // PR：https://github.com/tacoms-inc-dev/camel-dashboard-react-frontend/pull/582
  public async registration(body: RegistrationForm): Promise<void> {
    return await this.restClient.post<RegistrationForm, void>(
      `${TABLET_API_ORIGIN}/password-set` as const,
      body
    );
  }

  public async passwordResetRequest(
    body: PasswordResetRequestForm
  ): Promise<void> {
    return await this.restClient.post<PasswordResetRequestForm, void>(
      `${DASHBOARD_API_ORIGIN}/password-reset` as const,
      body
    );
  }

  public async passwordReset(body: PasswordResetForm): Promise<void> {
    return await this.restClient.patch<PasswordResetForm, void>(
      `${DASHBOARD_API_ORIGIN}/password-reset` as const,
      body
    );
  }

  public async resendEmailRequest(body: ResendEmailRequestForm): Promise<void> {
    return await this.restClient.post<ResendEmailRequestForm, void>(
      `${DASHBOARD_API_ORIGIN}/signup/retry` as const,
      body
    );
  }

  public async validateToken(body: ValidateTokenForm): Promise<void> {
    return await this.restClient.post<ValidateTokenForm, void>(
      `${DASHBOARD_API_ORIGIN}/token` as const,
      body
    );
  }
}
